module.exports = __webpack_public_path__ + "static/media/S (153).4fd04832.jpg";